"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMenuItems = void 0;

var _tslib = require("tslib");

var _react = require("react");

var _reactQuery = require("react-query");

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _settings = require("../../settings");

var _utiltity = require("../utiltity");

var _useFlavorPicker = require("./useFlavorPicker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useMenuItems = function useMenuItems(slug) {
  var _a;

  var queryClient = (0, _reactQuery.useQueryClient)();
  var menu = queryClient.getQueryData("Menu"
  /* Menu */
  );
  var settings = (0, _settings.useSettings)().data;
  var flavorPickerItems = (0, _useFlavorPicker.useFlavorPicker)().data;
  var isFlavorPickerEnabled = ((_a = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _a === void 0 ? void 0 : _a.FLAVOR_PICKER) && (0, _isArray2["default"])(flavorPickerItems) && flavorPickerItems.length;
  var standardMenuItems = (0, _react.useMemo)(function () {
    if (menu) {
      return slug ? (0, _utiltity.getItemsByType)(menu, slug) : (0, _utiltity.getFormattedMenuItems)(menu === null || menu === void 0 ? void 0 : menu.menuTypes);
    } else {
      return [];
    }
  }, [slug, menu]);
  var flavorMenuItems = (0, _react.useMemo)(function () {
    var processedFlavorPickers = [];

    if (menu) {
      var menuItemsByType_1 = slug ? (0, _utiltity.getItemsByType)(menu, slug) : (0, _utiltity.getFormattedMenuItems)(menu === null || menu === void 0 ? void 0 : menu.menuTypes);
      var filteredItems = (0, _map2["default"])(menuItemsByType_1, function (item) {
        var itemHasBeenProccessed = (0, _find2["default"])(processedFlavorPickers, function (id) {
          return id === item.itemId;
        });
        var flavorDetails = (0, _find2["default"])(flavorPickerItems, {
          itemId: item.itemId
        });

        if (flavorDetails && !itemHasBeenProccessed) {
          processedFlavorPickers.push(item.itemId);
          var flavorItems = (0, _filter2["default"])(menuItemsByType_1, function (menuItem) {
            return item.itemId === menuItem.itemId;
          });
          (0, _forEach2["default"])(flavorItems, function (flavorItem) {
            flavorItem.isFlavorItem = true;
          });
          return (0, _tslib.__assign)((0, _tslib.__assign)({}, item), {
            flavorItems: flavorItems,
            flavorDetails: flavorDetails
          });
        }

        if (itemHasBeenProccessed) {
          return false;
        }

        return item;
      });
      return (0, _compact2["default"])(filteredItems);
    } else {
      return [];
    }
  }, [flavorPickerItems, menu, slug]);
  return isFlavorPickerEnabled ? flavorMenuItems : standardMenuItems;
};

exports.useMenuItems = useMenuItems;